import { render, staticRenderFns } from "./frwmeDiagnosis.vue?vue&type=template&id=eb81dd64&scoped=true&"
import script from "./frwmeDiagnosis.vue?vue&type=script&lang=js&"
export * from "./frwmeDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./frwmeDiagnosis.vue?vue&type=style&index=0&id=eb81dd64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb81dd64",
  null
  
)

export default component.exports